import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { FaUserMd, FaCalendarAlt, FaSave } from "react-icons/fa";
// import '../styles/DutyRoster.css'; // Removed as requested

const DutyRosterBulk = () => {
     const token = sessionStorage.getItem("token") || localStorage.getItem("token");
     const BASE_URL = process.env.REACT_APP_BASE_URL;
     const [employees, setEmployees] = useState([]);
     const [selectedDoctors, setSelectedDoctors] = useState([]);
     const [doctorShiftsList, setDoctorShiftsList] = useState([]);
     const [employeeShiftsList, setEmployeeShiftsList] = useState([]);
     const [poojariShiftsList, setPoojariShiftsList] = useState([]);
     const [selectedShift, setSelectedShift] = useState("");
     const [selectedMonth, setSelectedMonth] = useState("");
     const [isLoading, setIsLoading] = useState(false);
     const [searchText, setSearchText] = useState("");
     const [employeeType, setEmployeeType] = useState("");


     const fetchEmployees = async () => {
          try {
               const response = await fetch(`${BASE_URL}/getEmployees`, {
                    method: "GET",
                    headers: {
                         "Content-Type": "application/json",
                         "Authorization": `Bearer ${token}`,
                    },
               });
               const result = await response.json();
               console.log('API Employees:', result.data); // Debug log
               console.log('employeeType:', employeeType);
               let filteredEmployees = [];
               if (employeeType === "DOCTOR") {
                    filteredEmployees = Array.isArray(result.data)
                         ? result.data.filter(emp => emp.emp_type === "DOCTOR")
                         : [];
               } else if (employeeType === "CONTRACTUAL_EMPLOYEE") {
                    filteredEmployees = Array.isArray(result.data)
                         ? result.data.filter(emp => emp.emp_type === "CONTRACTUAL_EMPLOYEE")
                         : [];
               } else if (employeeType === "POOJARI") {
                    filteredEmployees = Array.isArray(result.data)
                         ? result.data.filter(emp => emp.emp_type === "POOJARI")
                         : [];
               }
               console.log('Filtered Employees:', filteredEmployees); // Debug log
               setEmployees(filteredEmployees);
          } catch (error) {
               console.error("Error fetching employees:", error);
          }
     };

     const fetchShifts = async () => {
          try {
               let URL = "";
               if (employeeType === "DOCTOR") {
                    URL = `${BASE_URL}/getDoctorShifts`;
               } else if (employeeType === "CONTRACTUAL_EMPLOYEE" || employeeType === "POOJARI") {
                    URL = `${BASE_URL}/getShifts`;
               }
               if (!URL) return; // No valid employeeType selected

               const response = await fetch(URL, {
                    method: "GET",
                    headers: {
                         "Content-Type": "application/json",
                         "Authorization": `Bearer ${token}`,
                    },
               });
               const result = await response.json();
               // Set shifts based on employee type
               if (employeeType === "DOCTOR") {
                    setDoctorShiftsList(Array.isArray(result.data) ? result.data : []);
               } else if (employeeType === "CONTRACTUAL_EMPLOYEE") {
                    setEmployeeShiftsList(Array.isArray(result.data) ? result.data : []);
               } else if (employeeType === "POOJARI") {
                    setPoojariShiftsList(Array.isArray(result.data) ? result.data : []);
               }


          } catch (error) {
               console.error("Error fetching shifts:", error);
          }
     };



     const handleSubmit = async () => {
          if (!selectedMonth || !selectedShift || selectedDoctors.length === 0) {
               toast.error("Please select month, shift, and at least one doctor.");
               return;
          }
          setIsLoading(true);

          // derive emp codes for selected doctors (handle different property names and remove duplicates)
          const empCodes = Array.from(new Set(
               selectedDoctors
                    .map(id => {
                         const emp = employees.find(e => e.emp_id == id);
                         // employees use employee_code in the UI; fall back to emp_code if present
                         return emp ? (emp.employee_code ?? emp.emp_code ?? null) : null;
                    })
                    .filter(Boolean)
          ));

          const payload = {
               month: selectedMonth,
               shift_id: selectedShift,
               emp_ids: selectedDoctors,
               emp_code: empCodes, // included emp_code in payload
          };
          const loadingToast = toast.loading("Mapping shifts to selected doctors...");
          try {
               const response = await fetch(`${BASE_URL}/createDutyRosterBulk`, {
                    method: "POST",
                    headers: {
                         "Content-Type": "application/json",
                         "Authorization": `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
               });
               const result = await response.json();
               toast.update(loadingToast, {
                    render: result.message || "Duty roster mapped successfully!",
                    type: 'success',
                    isLoading: false,
                    autoClose: 3000
               });
               setSelectedDoctors([]);
               setSelectedShift("");
               setSelectedMonth("");
          } catch (error) {
               toast.update(loadingToast, {
                    render: "Error mapping roster",
                    type: 'error',
                    isLoading: false,
                    autoClose: 3000
               });
          } finally {
               setIsLoading(false);
          }
     };

     useEffect(() => {
          if (employeeType) {
               fetchShifts();
               fetchEmployees();
          }
     }, [employeeType]);

     const handleSelectEmployeeType = (e) => {
          const val = e.target.value;
          setEmployeeType(val);
     };

     return (
          <div>
               <ToastContainer position="top-right" />
               <div className="card">
                    <h4 style={{ marginBottom: "15px" }}>Duty Roster Bulk Mapping</h4>

                    <div className="row" style={{ alignItems: "flex-start" }}>
                         <div className="col-auto" style={{ minWidth: 280 }}>
                              <label style={{ fontWeight: 500, fontSize: "15px", marginRight: "6px", marginBottom: "6px" }}>
                                   <FaCalendarAlt /> Employee Type
                              </label>
                              <select
                                   className="filter-input"
                                   value={employeeType}
                                   onChange={handleSelectEmployeeType}
                                   style={{
                                        fontSize: "14px",
                                        padding: "6px 10px",
                                        borderRadius: "6px",
                                        border: "1px solid #d1d5db",
                                        width: "200px"
                                   }}
                              >
                                   <option value="">Select Employee Type</option>
                                   <option value="DOCTOR">Doctor</option>
                                   <option value="CONTRACTUAL_EMPLOYEE">Contractual Employee</option>
                                   <option value="POOJARI">Poojari</option>
                              </select>
                         </div>
                         {employeeType && (
                              <>
                                   <div className="col-auto" style={{ minWidth: 280 }}>
                                        <label style={{ fontWeight: 500, fontSize: "15px", marginRight: "6px", marginBottom: "6px" }}>
                                             <FaCalendarAlt /> Month
                                        </label>
                                        <input
                                             type="month"
                                             className="filter-input"
                                             min="2025-08"
                                             value={selectedMonth}
                                             onChange={e => setSelectedMonth(e.target.value)}
                                             style={{
                                                  fontSize: "14px",
                                                  padding: "6px 10px",
                                                  borderRadius: "6px",
                                                  border: "1px solid #d1d5db",
                                                  width: "200px"
                                             }}
                                        />
                                   </div>
                                   {/* show when employeeType is selected */}

                                   <div className="col-auto" style={{ minWidth: 280 }}>
                                        <label style={{ fontWeight: 500, fontSize: "15px", marginRight: "6px", marginBottom: "6px" }}>
                                             <FaUserMd /> Shift
                                        </label>
                                        <select
                                             className="filter-input"
                                             value={selectedShift}
                                             onChange={e => setSelectedShift(e.target.value)}
                                             style={{
                                                  fontSize: "14px",
                                                  padding: "6px 10px",
                                                  borderRadius: "6px",
                                                  border: "1px solid #d1d5db",
                                                  width: "200px"
                                             }}
                                        >
                                             <option value="">Select Shift</option>
                                             {employeeType === "DOCTOR" && doctorShiftsList.map(shift => (
                                                  <option key={shift.id} value={shift.id}>
                                                       {shift.shift_name} ({shift.in_time} - {shift.out_time})
                                                  </option>
                                             ))}
                                             {employeeType === "CONTRACTUAL_EMPLOYEE" && employeeShiftsList.map(shift => (
                                                  <option key={shift.id} value={shift.id}>
                                                       {shift.ShiftName} ({shift.ShiftStart} - {shift.ShiftEnd})
                                                  </option>
                                             ))}
                                             {employeeType === "POOJARI" && poojariShiftsList.map(shift => (
                                                  <option key={shift.id} value={shift.id}>
                                                       {shift.ShiftName} ({shift.ShiftStart} - {shift.ShiftEnd})
                                                  </option>
                                             ))}
                                        </select>
                                   </div>
                              </>
                         )}
                         <div className="col-md-auto" style={{ minWidth: 320 }}>
                              <label style={{ fontWeight: 500, fontSize: "15px", marginBottom: "6px" }}>
                                   <FaUserMd /> Employees / Doctors
                              </label>

                              {selectedMonth && selectedShift && (
                                   <div
                                        className="checkbox-list"
                                        style={{
                                             maxHeight: "500px",
                                             overflowY: "auto",
                                             border: "1px solid #e5e7eb",
                                             borderRadius: "10px",
                                             padding: "12px",
                                             background: "#fff",
                                             opacity: 1,
                                             transition: "background 0.2s, opacity 0.2s",
                                             display: "flex",
                                             flexWrap: "wrap",
                                             gap: "8px"
                                        }}
                                   >
                                        {/* Search input */}
                                        <input
                                             type="text"
                                             placeholder={employeeType === "DOCTOR" ? "Search doctor..." : employeeType === "CONTRACTUAL_EMPLOYEE" ? "Search employee..." : "Search poojari..."}
                                             value={searchText}
                                             onChange={e => setSearchText(e.target.value)}
                                             style={{
                                                  width: "100%",
                                                  marginBottom: "12px",
                                                  padding: "8px",
                                                  borderRadius: "6px",
                                                  border: "1px solid #e5e7eb",
                                                  fontSize: "14px"
                                             }}
                                        />
                                        {employees
                                             .filter(emp =>
                                                  emp.employee_name.toLowerCase().includes(searchText.toLowerCase()) ||
                                                  emp.employee_code.toLowerCase().includes(searchText.toLowerCase())
                                             )
                                             .map(emp => (
                                                  <label
                                                       key={emp.emp_id}
                                                       style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            marginBottom: "0",
                                                            cursor: "pointer",
                                                            padding: "6px 14px",
                                                            borderRadius: "20px",
                                                            background: "#f9fafb",
                                                            boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
                                                            fontSize: "14px",
                                                            fontWeight: 500,
                                                            border: selectedDoctors.includes(emp.emp_id) ? "2px solid #2563eb" : "1px solid #e5e7eb",
                                                            color: selectedDoctors.includes(emp.emp_id) ? "#2563eb" : "#222",
                                                            transition: "all 0.2s"
                                                       }}
                                                  >
                                                       <input
                                                            type="checkbox"
                                                            value={emp.emp_id}
                                                            checked={selectedDoctors.includes(emp.emp_id)}
                                                            onChange={e => {
                                                                 if (e.target.checked) {
                                                                      setSelectedDoctors([...selectedDoctors, emp.emp_id]);
                                                                 } else {
                                                                      setSelectedDoctors(selectedDoctors.filter(id => id !== emp.emp_id));
                                                                 }
                                                            }}
                                                            style={{ marginRight: "8px" }}
                                                       />
                                                       <span>{emp.employee_code} - {emp.employee_name}</span>
                                                  </label>
                                             ))}
                                        {employees.length === 0 && (
                                             <div>
                                                  {employeeType === "DOCTOR"
                                                       ? "No doctors found."
                                                       : employeeType === "CONTRACTUAL_EMPLOYEE"
                                                            ? "No employees found."
                                                            : "No poojari found."}
                                             </div>
                                        )}
                                   </div>
                              )}
                              {/* Show message when month or shift not selected */}
                              {(!selectedMonth || !selectedShift) && (
                                   <div
                                        style={{
                                             border: "1px solid #e5e7eb",
                                             borderRadius: "10px",
                                             padding: "24px",
                                             background: "#f3f4f6",
                                             opacity: 0.8,
                                             color: "#64748b",
                                             fontSize: "16px",
                                             textAlign: "center",
                                             marginTop: "12px"
                                        }}
                                   >
                                        Please select Month and Shift to enable doctor selection.
                                   </div>
                              )}
                              {/* <div
                                   className="checkbox-list"
                                   style={{
                                        maxHeight: "500px",
                                        overflowY: "auto",
                                        border: "1px solid #e5e7eb",
                                        borderRadius: "10px",
                                        padding: "12px",
                                        background: (!selectedMonth || !selectedShift) ? "#f3f4f6" : "#fff",
                                        opacity: (!selectedMonth || !selectedShift) ? 0.6 : 1,
                                        transition: "background 0.2s, opacity 0.2s",
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "8px"
                                   }}
                              >
                                   {employees.map(emp => (
                                        <label
                                             key={emp.emp_id}
                                             style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  marginBottom: "0",
                                                  cursor: (!selectedMonth || !selectedShift) ? "not-allowed" : "pointer",
                                                  padding: "6px 14px",
                                                  borderRadius: "20px",
                                                  background: "#f9fafb",
                                                  boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
                                                  fontSize: "14px",
                                                  fontWeight: 500,
                                                  border: selectedDoctors.includes(emp.emp_id) ? "2px solid #2563eb" : "1px solid #e5e7eb",
                                                  color: selectedDoctors.includes(emp.emp_id) ? "#2563eb" : "#222",
                                                  transition: "all 0.2s"
                                             }}
                                             className={(!selectedMonth || !selectedShift) ? "disabled-label" : ""}
                                        >
                                             <input
                                                  type="checkbox"
                                                  value={emp.emp_id}
                                                  checked={selectedDoctors.includes(emp.emp_id)}
                                                  disabled={!selectedMonth || !selectedShift}
                                                  onChange={e => {
                                                       if (e.target.checked) {
                                                            setSelectedDoctors([...selectedDoctors, emp.emp_id]);
                                                       } else {
                                                            setSelectedDoctors(selectedDoctors.filter(id => id !== emp.emp_id));
                                                       }
                                                  }}
                                                  style={{ marginRight: "8px" }}
                                             />
                                             <span>{emp.employee_code} - {emp.employee_name}</span>
                                        </label>
                                   ))}
                                   {(!selectedMonth || !selectedShift) && (
                                        <div style={{ color: "#64748b", fontSize: "14px", textAlign: "center", width: "100%", marginTop: "12px" }}>
                                             Please select Month and Shift to enable doctor selection.
                                        </div>
                                   )}
                              </div> */}
                              <small style={{ color: "#64748b" }}>Select or deselect doctors using checkboxes</small>
                         </div>
                         <div className="col-md-2" style={{ display: "flex", alignItems: "flex-end" }}>
                              <button
                                   className="save-btn"
                                   onClick={handleSubmit}
                                   disabled={isLoading}
                                   style={{
                                        background: "#2563eb",
                                        color: "#fff",
                                        borderRadius: "8px",
                                        padding: "10px 18px",
                                        fontWeight: 600,
                                        fontSize: "15px",
                                        border: "none",
                                        boxShadow: "0 2px 8px rgba(37,99,235,0.08)",
                                        transition: "background 0.2s"
                                   }}
                              >
                                   <FaSave style={{ marginRight: "8px" }} /> Assign Shifts
                              </button>
                         </div>
                    </div>
               </div>
          </div>
     );
};

export default DutyRosterBulk;